import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-terminos-condiciones-web',
  templateUrl: './terminos-condiciones-web.component.html',
  styleUrls: ['./terminos-condiciones-web.component.scss']
})
export class TerminosCondicionesWebComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  irAUrlAnterior() {
    this.location.back();
  }

}
